import { render, staticRenderFns } from "./PullRequestTimeline.vue?vue&type=template&id=1d49fa36"
import script from "./PullRequestTimeline.vue?vue&type=script&lang=ts"
export * from "./PullRequestTimeline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports